function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
var __vue_script__ = {
  name: 'Notice',
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    duration: {
      type: [Number, String],
      // ms
      default: 1500
    },
    content: {
      type: [String, Object],
      default: ''
    },
    dangerouslySetInnerHTML: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    noticeClass: {
      type: [String, Array, Object],
      default: ''
    },
    noticeStyle: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      timer: null,
      isClose: false
    };
  },
  computed: {
    noticePrefixCls: function noticePrefixCls() {
      return "".concat(this.prefixCls, "-notice");
    },
    classes: function classes() {
      var _ref;

      var noticePrefixCls = this.noticePrefixCls,
          closable = this.closable;
      return _ref = {}, _defineProperty(_ref, noticePrefixCls, true), _defineProperty(_ref, "".concat(noticePrefixCls, "-closable"), closable), _ref;
    }
  },
  created: function created() {
    this.startTimer();
  },
  beforeDestroy: function beforeDestroy() {
    var clearTimer = this.clearTimer;
    clearTimer();
  },
  methods: {
    close: function close() {
      this.clearTimer();
      this.$emit('close');
    },
    startTimer: function startTimer() {
      var duration = this.duration,
          close = this.close,
          clearTimer = this.clearTimer,
          timer = this.timer;

      if (timer) {
        clearTimer();
      }

      if (duration) {
        this.timer = setTimeout(function () {
          close();
        }, duration);
      }
    },
    clearTimer: function clearTimer() {
      var timer = this.timer;

      if (timer) {
        clearTimeout(timer);
        this.timer = null;
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var noticePrefixCls = this.noticePrefixCls,
        classes = this.classes,
        noticeClass = this.noticeClass,
        noticeStyle = this.noticeStyle,
        closable = this.closable,
        dangerouslySetInnerHTML = this.dangerouslySetInnerHTML,
        content = this.content,
        clearTimer = this.clearTimer,
        startTimer = this.startTimer,
        close = this.close;
    var noticeContent = dangerouslySetInnerHTML ? h("div", {
      "class": "".concat(noticePrefixCls, "-content"),
      "domProps": _objectSpread({}, {
        innerHTML: content
      })
    }) : h("div", {
      "class": "".concat(noticePrefixCls, "-content")
    }, [content]);
    return h("div", {
      "class": [classes, noticeClass],
      "style": noticeStyle,
      "on": {
        "mouseenter": clearTimer,
        "mouseleave": startTimer
      }
    }, [noticeContent, closable ? h("div", {
      "class": "".concat(noticePrefixCls, "-close"),
      "on": {
        "click": close
      }
    }, [h("span", {
      "class": "".concat(noticePrefixCls, "-close-x")
    })]) : null]);
  }
};
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "notice.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);